export default __webpack_public_path__ + "static/media/thafavoreto.f7be2aa9.jpg";